"use strict";

const elements = require("client/pages/bictoleisearch/elements");
const staticData = require("client/static_data");
const dataAccess = require("client/pages/bictoleisearch/data_access")();

/**
 * The dialog payload must carry the email type the server dispatches on
 * (server/routes/api.js): it selects the email message and the per-IP counter
 * the request consumes. The value comes from static_data so the server stays
 * the single source of it (constants.email_types).
 */
const EMAIL_TYPE = staticData.email_types.BICTOLEI_TXT_DOWNLOAD;

function _getInputs (container) {
    if (container) {
        const inputs = Array.from(container.querySelectorAll("swiftref-input"));
        const dropdowns = Array.from(container.querySelectorAll("swiftref-dropdown"));
        const checkboxes = Array.from(container.querySelectorAll("swiftref-checkbox"));
        return inputs.concat(dropdowns, checkboxes);
    }
    return [];
}

function _renderBanner({state, text, clear_icon, append}) {
    if (append !== true) {
        elements.banner_container.innerHTML = "";
    }
    const banner = document.createElement("swiftref-banner");
    banner.setAttribute("state", state || "success");
    banner.innerHTML = text || "";
    elements.banner_container.appendChild(banner);
    if (clear_icon && clear_icon === true) {
        banner.setAttribute("clear_icon", "");
    }
}

function _clearErrors () {
    for (const input of _getInputs(elements.txt_file_dialog)) {
        input.removeAttribute("message");
        input.removeAttribute("state");
    }
}

function _clearInputsValue () {
    for (const input of _getInputs(elements.txt_file_dialog)) {
        if (input.tagName === "SWIFTREF-CHECKBOX") {
            input.checked = false;
        } else {
            input.value = "";
        }
    }
}

function _renderErrors (fields) {
    const inputsByName = {};
    for (const input of _getInputs(elements.txt_file_dialog)) {
        inputsByName[input.name] = input;
    }
    let marked = false;
    for (const fieldName in fields) {
        const input = inputsByName[fieldName];
        if (input) {
            input.setAttribute("state", "invalid");
            input.setAttribute("message", fields[fieldName]);
            marked = true;
        }
    }
    /**
     * A schema-level rejection (or a server error) carries no per-field detail,
     * so it would leave the dialog visually unchanged: report it on the page
     * banner instead (see LEARNED.md).
     */
    if (!marked) {
        _renderBanner({
            state: "warning",
            text: staticData.errors.INVALID_PARAMS.message
        });
    }
}

const presentation = {

    "bindEventListeners": function () {

        if (elements.page_wrapper) {
            elements.page_wrapper.addEventListener("click", function (event) {
                const action = event.target.dataset.action;

                switch (action) {
                    case "open-dialog":
                        _clearErrors();
                        elements.txt_file_dialog.show();
                        return;

                    case "send-bictolei-email":
                        _sendEmail();
                        return;

                    /**
                     * The specifications PDF: checked with a HEAD first (data_access
                     * DOWNLOAD_FILE), like the ISO 9362 PDF, so a missing file shows
                     * the "temporarily not available" banner instead of navigating
                     * to the route's raw JSON 404.
                     */
                    case "download-specifications": {
                        event.preventDefault();
                        const href = event.target.href;
                        if (href) {
                            document.dispatchEvent(
                                new CustomEvent('DOWNLOAD_FILE', {"detail": {href}})
                            );
                        }
                        return;
                    }

                    default:
                        return;
                }
            });
        }

        if (elements.txt_file_dialog) {
            elements.txt_file_dialog.addEventListener("hide", function () {
                _clearErrors();
                _clearInputsValue();
            });
        }
    },

    "renderBanner": _renderBanner
};

function _onSendError (error) {
    const response = error.response;
    if (!response) {
        _renderBanner({
            state: "warning",
            text: staticData.errors.UNABLE_TO_SEND_EMAIL.message
        });
        return;
    }
    /**
     * The quota is spent (the server answers with the number_of_txt_email_exceeded
     * name, server/error_handler.js), or the release is missing on the server
     * (file_not_found, server/hooks/email/file_check.js): neither is fixable in the
     * dialog, so close it and say why on the banner.
     */
    const name = response.data?.name;
    if (name === staticData.errors.NUMBER_OF_TXT_EMAIL_EXCEEDED.name || name === staticData.errors.FILE_NOT_FOUND.name) {
        elements.txt_file_dialog.hide();
        _renderBanner({
            state: "warning",
            text: response.data.message
        });
        return;
    }
    _renderErrors(response.data?.fields || {});
}

function _sendEmail () {
    _clearErrors();
    const payload = {
        email_type: EMAIL_TYPE
    };
    for (const field of _getInputs(elements.txt_file_dialog)) {
        if (field.tagName === "SWIFTREF-CHECKBOX") {
            payload[field.getAttribute("name")] = field.checked;
        } else {
            payload[field.getAttribute("name")] = field.value || "";
        }
    }

    dataAccess.sendTextEmail(payload).then(function (response) {
        elements.txt_file_dialog.hide();
        _renderBanner({
            state: "success",
            text: response.data.message
        });
    }).catch(_onSendError);
}

/**
 * The emailed link is <page>?token=<token>: the download endpoint expects the
 * token in the query string, so it is forwarded as it is.
 */
if (window.location.search?.includes("token")) {
    document.dispatchEvent(
        new CustomEvent('DOWNLOAD_FILE', {
            "detail": {
                href: staticData.links.link_06 + window.location.search
            }
        })
    );
}

document.addEventListener('DOWNLOAD_FILE_ERROR', (e) => {
    _renderBanner({
        state: "warning",
        text: e.detail.error
    });
});

module.exports = presentation;
